module.exports = __webpack_public_path__ + "img/ecopayz.37e44f76.png";